type LoginRedirectQueryValue = string | string[] | null | undefined

/**
 * 取路由 query 中第一个有效字符串值。
 */
export const getFirstLoginRedirectQueryValue = (value: LoginRedirectQueryValue) => {
  if (Array.isArray(value)) {
    return value[0] || ''
  }

  return value || ''
}

/**
 * 根据当前语言生成登录后的默认回跳地址。
 */
export const resolveDefaultLoginRedirectUrl = (languageCode: string) =>
  languageCode === 'en' ? '/' : `/${languageCode}/`

/**
 * 解析第三方登录/注册完成后的回跳地址，同域名场景下沿用当前协议。
 */
export const resolveLoginRedirectUrl = (
  returnUrlValue: LoginRedirectQueryValue,
  fallbackUrl: string,
  currentOrigin = '',
) => {
  const returnUrl = getFirstLoginRedirectQueryValue(returnUrlValue).trim()
  if (!returnUrl) {
    return fallbackUrl
  }

  if (returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
    return returnUrl
  }

  try {
    const targetUrl = new URL(returnUrl)

    if (currentOrigin) {
      const currentUrl = new URL(currentOrigin)
      if (targetUrl.host === currentUrl.host) {
        return `${currentUrl.origin}${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`
      }
    }

    return targetUrl.href
  } catch {
    return fallbackUrl
  }
}
